var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4467 13.3974C15.4182 12.1956 16 10.6657 16 9C16 5.13401 12.866 2 9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16C10.6657 16 12.1956 15.4182 13.3974 14.4467C13.4191 14.4759 13.4432 14.5038 13.4697 14.5303L15.2226 16.2833C14.8844 16.6762 14.9016 17.2695 15.2741 17.642L19.1801 21.548C19.5526 21.9205 20.1459 21.9377 20.5388 21.5995L20.5407 21.6014L20.5846 21.5575L20.5943 21.548L21.5482 20.5941L21.5577 20.5844L21.6014 20.5407L21.5995 20.5388C21.9379 20.1459 21.9208 19.5525 21.5482 19.1799L17.6422 15.2739C17.2696 14.9013 16.6762 14.8842 16.2833 15.2226L14.5303 13.4697C14.5038 13.4432 14.4759 13.4191 14.4467 13.3974ZM5 8.25H13C13.4142 8.25 13.75 8.58579 13.75 9C13.75 9.41421 13.4142 9.75 13 9.75H5C4.58579 9.75 4.25 9.41421 4.25 9C4.25 8.58579 4.58579 8.25 5 8.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.3d156507a89f91482a02fdaae83965a8.svg";
export { ForwardRef as ReactComponent };